import { gql } from '@apollo/client';

export const fetchLinkedEntitlementChangeSubscription = gql`
  query fetchLinkedEntitlementChangeSubscription(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        id
        entitlementNumber
        productId
        productName
        offeringId
      }
    }
  }
`;
